document.addEventListener("DOMContentLoaded", () => {
    function scrollToHash(id, offset = 0) {
        const element = document.getElementById(id)
        if (!element) return

        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
        const offsetPosition = elementPosition - offset

        window.scrollTo({ top: offsetPosition, behavior: 'smooth' })
    }

    document.querySelectorAll('a[href*="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const href = this.getAttribute('href')
            const hashIndex = href.indexOf('#')
            if (hashIndex === -1) return

            const targetId = href.substring(hashIndex + 1)
            
            const linkPath = href.substring(0, hashIndex) || window.location.pathname
            if (linkPath !== window.location.pathname) return

            e.preventDefault()
            scrollToHash(targetId, offset)
        })
    })
})
